const TIMEZONE_COUNTRY_MAP = {
  'Asia/Kolkata': 'India',
  'Asia/Calcutta': 'India',

  // United States
  'America/New_York': 'United States',
  'America/Chicago': 'United States',
  'America/Denver': 'United States',
  'America/Los_Angeles': 'United States',
  'America/Phoenix': 'United States',
  'America/Anchorage': 'United States',
  'America/Boise': 'United States',
  'America/Detroit': 'United States',
  'America/Indiana/Indianapolis': 'United States',
  'America/Indiana/Knox': 'United States',
  'America/Indiana/Marengo': 'United States',
  'America/Indiana/Petersburg': 'United States',
  'America/Indiana/Tell_City': 'United States',
  'America/Indiana/Vevay': 'United States',
  'America/Indiana/Vincennes': 'United States',
  'America/Indiana/Winamac': 'United States',
  'America/Juneau': 'United States',
  'America/Kentucky/Louisville': 'United States',
  'America/Kentucky/Monticello': 'United States',
  'America/Menominee': 'United States',
  'America/Nome': 'United States',
  'America/North_Dakota/Beulah': 'United States',
  'America/North_Dakota/Center': 'United States',
  'America/North_Dakota/New_Salem': 'United States',
  'America/Sitka': 'United States',
  'America/Yakutat': 'United States',
  'America/Adak': 'United States',
  'Pacific/Honolulu': 'United States',

  // Canada
  'America/Toronto': 'Canada',
  'America/Vancouver': 'Canada',
  'America/Edmonton': 'Canada',
  'America/Halifax': 'Canada',
  'America/Winnipeg': 'Canada',
  'America/St_Johns': 'Canada',
  'America/Regina': 'Canada',
  'America/Moncton': 'Canada',
  'America/Thunder_Bay': 'Canada',
  'America/Whitehorse': 'Canada',
  'America/Dawson': 'Canada',
  'America/Dawson_Creek': 'Canada',
  'America/Fort_Nelson': 'Canada',
  'America/Creston': 'Canada',
  'America/Iqaluit': 'Canada',
  'America/Rankin_Inlet': 'Canada',
  'America/Resolute': 'Canada',
  'America/Cambridge_Bay': 'Canada',
  'America/Inuvik': 'Canada',
  'America/Glace_Bay': 'Canada',
  'America/Goose_Bay': 'Canada',
  'America/Swift_Current': 'Canada',
  'America/Atikokan': 'Canada',
  'America/Nipigon': 'Canada',
  'America/Rainy_River': 'Canada',
  'America/Blanc-Sablon': 'Canada',

  // Mexico
  'America/Mexico_City': 'Mexico',
  'America/Cancun': 'Mexico',
  'America/Merida': 'Mexico',
  'America/Monterrey': 'Mexico',
  'America/Matamoros': 'Mexico',
  'America/Mazatlan': 'Mexico',
  'America/Chihuahua': 'Mexico',
  'America/Ojinaga': 'Mexico',
  'America/Hermosillo': 'Mexico',
  'America/Tijuana': 'Mexico',
  'America/Bahia_Banderas': 'Mexico',

  // Brazil
  'America/Sao_Paulo': 'Brazil',
  'America/Noronha': 'Brazil',
  'America/Belem': 'Brazil',
  'America/Fortaleza': 'Brazil',
  'America/Recife': 'Brazil',
  'America/Araguaina': 'Brazil',
  'America/Maceio': 'Brazil',
  'America/Bahia': 'Brazil',
  'America/Campo_Grande': 'Brazil',
  'America/Cuiaba': 'Brazil',
  'America/Santarem': 'Brazil',
  'America/Porto_Velho': 'Brazil',
  'America/Boa_Vista': 'Brazil',
  'America/Manaus': 'Brazil',
  'America/Eirunepe': 'Brazil',
  'America/Rio_Branco': 'Brazil',

  // Argentina
  'America/Argentina/Buenos_Aires': 'Argentina',
  'America/Argentina/Cordoba': 'Argentina',
  'America/Argentina/Salta': 'Argentina',
  'America/Argentina/Jujuy': 'Argentina',
  'America/Argentina/Tucuman': 'Argentina',
  'America/Argentina/Catamarca': 'Argentina',
  'America/Argentina/La_Rioja': 'Argentina',
  'America/Argentina/San_Juan': 'Argentina',
  'America/Argentina/Mendoza': 'Argentina',
  'America/Argentina/San_Luis': 'Argentina',
  'America/Argentina/Rio_Gallegos': 'Argentina',
  'America/Argentina/Ushuaia': 'Argentina',

  // Chile
  'America/Santiago': 'Chile',
  'America/Punta_Arenas': 'Chile',

  // Colombia
  'America/Bogota': 'Colombia',

  // Peru
  'America/Lima': 'Peru',

  // Ecuador
  'America/Guayaquil': 'Ecuador',

  // Venezuela
  'America/Caracas': 'Venezuela',

  // Bolivia
  'America/La_Paz': 'Bolivia',

  // Paraguay
  'America/Asuncion': 'Paraguay',

  // Uruguay
  'America/Montevideo': 'Uruguay',

  // Central America
  'America/Guatemala': 'Guatemala',
  'America/Belize': 'Belize',
  'America/El_Salvador': 'El Salvador',
  'America/Tegucigalpa': 'Honduras',
  'America/Managua': 'Nicaragua',
  'America/Costa_Rica': 'Costa Rica',
  'America/Panama': 'Panama',

  // Caribbean
  'America/Havana': 'Cuba',
  'America/Jamaica': 'Jamaica',
  'America/Port-au-Prince': 'Haiti',
  'America/Santo_Domingo': 'Dominican Republic',
  'America/Puerto_Rico': 'Puerto Rico',
  'America/Nassau': 'Bahamas',
  'America/Grand_Turk': 'Turks and Caicos Islands',
  'America/Cayman': 'Cayman Islands',
  'America/Port_of_Spain': 'Trinidad and Tobago',
  'America/Barbados': 'Barbados',
  'America/Martinique': 'Martinique',
  'America/Guadeloupe': 'Guadeloupe',
  'America/Curacao': 'Curaçao',
  'America/Aruba': 'Aruba',
  'America/St_Vincent': 'Saint Vincent and the Grenadines',
  'America/St_Lucia': 'Saint Lucia',
  'America/St_Kitts': 'Saint Kitts and Nevis',
  'America/Antigua': 'Antigua and Barbuda',
  'America/Dominica': 'Dominica',
  'America/Grenada': 'Grenada',
  'America/Tortola': 'British Virgin Islands',
  'America/Montserrat': 'Montserrat',
  'America/Anguilla': 'Anguilla',
  'America/Kralendijk': 'Bonaire',
  'America/Lower_Princes': 'Sint Maarten',
  'America/Marigot': 'Saint Martin',
  'America/St_Barthelemy': 'Saint Barthélemy',

  // Other Americas
  'America/Cayenne': 'French Guiana',
  'America/Paramaribo': 'Suriname',
  'America/Guyana': 'Guyana',
  'America/Miquelon': 'Saint Pierre and Miquelon',
  'America/Nuuk': 'Greenland',
  'America/Scoresbysund': 'Greenland',
  'America/Danmarkshavn': 'Greenland',
  'America/Thule': 'Greenland',

  // Europe
  'Europe/London': 'United Kingdom',
  'Europe/Dublin': 'Ireland',
  'Europe/Berlin': 'Germany',
  'Europe/Paris': 'France',
  'Europe/Amsterdam': 'Netherlands',
  'Europe/Stockholm': 'Sweden',
  'Europe/Oslo': 'Norway',
  'Europe/Copenhagen': 'Denmark',
  'Europe/Zurich': 'Switzerland',
  'Europe/Brussels': 'Belgium',
  'Europe/Vienna': 'Austria',
  'Europe/Rome': 'Italy',
  'Europe/Madrid': 'Spain',
  'Europe/Lisbon': 'Portugal',

  // Asia-Pacific
  'Asia/Singapore': 'Singapore',
  'Asia/Dubai': 'United Arab Emirates',
  'Asia/Tokyo': 'Japan',
  'Asia/Seoul': 'South Korea',
  'Asia/Manila': 'Philippines',
  'Asia/Kuala_Lumpur': 'Malaysia',
  'Asia/Bangkok': 'Thailand',
  'Asia/Jakarta': 'Indonesia',
  'Asia/Riyadh': 'Saudi Arabia',
  'Asia/Qatar': 'Qatar',
  'Asia/Kuwait': 'Kuwait',
  'Asia/Bahrain': 'Bahrain',
  'Asia/Muscat': 'Oman',

  // Africa
  'Africa/Johannesburg': 'South Africa',
  'Africa/Lagos': 'Nigeria',
  'Africa/Nairobi': 'Kenya',
  'Africa/Accra': 'Ghana',
  'Africa/Cairo': 'Egypt',

  // Oceania
  'Australia/Sydney': 'Australia',
  'Australia/Melbourne': 'Australia',
  'Pacific/Auckland': 'New Zealand',
};

export function detectCountryFromTimezone(timezone) {
  if (!timezone) return null;
  if (TIMEZONE_COUNTRY_MAP[timezone]) {
    return TIMEZONE_COUNTRY_MAP[timezone];
  }
  const match = Object.keys(TIMEZONE_COUNTRY_MAP).find(
    (key) => timezone.startsWith(key + '/')
  );
  if (match) {
    return TIMEZONE_COUNTRY_MAP[match];
  }
  // Unknown America/* zones default to the US (the dominant case for that
  // prefix); any other unknown zone returns null so callers can fall back to
  // geo-IP (detectCountry) or their own default (getCountryCodeFromTimezone).
  if (timezone.startsWith('America/')) {
    return 'United States';
  }
  return null;
}

export function matchCountryInList(countryName, countries) {
  if (!countryName) return '';
  const matched = countries.find(
    (c) => c.toLowerCase() === countryName.toLowerCase()
  );
  return matched || countryName;
}

const US_TIMEZONES = Object.entries(TIMEZONE_COUNTRY_MAP)
  .filter(([, country]) => country === 'United States')
  .map(([tz]) => tz);

export function detectRegion() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz === 'Asia/Kolkata' || tz === 'Asia/Calcutta') return 'in';
    if (tz.startsWith('Europe/')) return 'eu';
    if (US_TIMEZONES.some(p => tz === p || tz.startsWith(p + '/'))) return 'us';
  } catch {
    // fall through
  }
  return 'global';
}

export async function detectCountry({ countries, onDetected }) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const fromTz = detectCountryFromTimezone(timezone);
  if (fromTz) {
    onDetected(matchCountryInList(fromTz, countries));
    return fromTz;
  }

  const apis = [
    { url: 'https://ip-api.com/json/?fields=country', getName: (d) => d.country },
    { url: 'https://ipapi.co/json/', getName: (d) => d.country_name },
  ];

  for (const source of apis) {
    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 4000);
      const res = await fetch(source.url, { signal: controller.signal });
      clearTimeout(timeout);
      if (!res.ok) continue;
      const data = await res.json();
      const countryName = source.getName(data);
      if (countryName) {
        onDetected(matchCountryInList(countryName, countries));
        return countryName;
      }
    } catch {
      continue;
    }
  }

  return null;
}
